<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        width="16" 
        height="16" 
        :fill="fillColor" 
        :class="svgClass" 
        viewBox="0 0 16 16"
    >
        <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z"/>
        <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8m0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
    </svg>
</template>
  

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['fill', 'iconClass'])

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-5 h-5'
})

const fillColor = computed(() => {
    return props.fill ? props.fill : 'black'
})

</script>